import React, {Component} from 'react'

import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import html2canvas from 'html2canvas'

import MainPaper from '../../../../component/MainPaper'
import OfflineFeedbackSheet from "../../components/OfflineFeedbackSheet"
import ToplessMain from "../../../../container/ToplessMain"
import OfflineVoucherButtons from "../../components/OfflineVoucherButtons"
import PmcVoucherButtons from "../../components/PmcVoucherButtons"
import { PAGO_MIS_CUENTAS } from '../../../../shared/constants'
import size from 'lodash/size'
import head from 'lodash/head'

/**
 * Container view hosting the content of the Offline Payment success information. It shows the possibility to navigate
 * to the configured Success page, Download or Print the Voucher with the Payment information.
 */
class OfflineFeedback extends Component {
    constructor(props) {
        super(props)

        this.state = {
            takingSnapShot: false,
            inShortVersion: false
        }
    }

    /**
     * Executed when the component has been mounted.
     */
    componentDidMount() {
        window.onresize = event => this.setState({...this.state, inShortVersion: event.target.innerWidth <= 611})
    }

    componentWillUnmount() {
        window.onresize = () => {
        }
    }

    /**
     * Shows the the Print Dialog of the browser.
     */
    printVoucher = () => {
        window.print()
    }

    /**
     * Executes the process of generating and downloading a PDF shot of the current view. It hides the command buttons
     * and generates a canvas with all the elements in the app's root element (as if a picture was taken). Such canvas
     * is then converted to PNG and downloaded such PNG as PDF.
     */
    downloadVoucher = () => {
        const printAreaElement = document.getElementById("printScreen")
        const oldWidth = printAreaElement.style.width
        const {inShortVersion} = this.state
        const operationNumber = escape(this.props.resultData.operationNumber)
        const commerceName = escape(this.props.resultData.establishmentName)

        printAreaElement.style.width = !inShortVersion ? '900px' : '600px'

        html2canvas(printAreaElement, {useCORS: true}).then(canvas => {
            const png = canvas.toDataURL("image/png")

            const fileName = `${commerceName}_${operationNumber}.pdf`
            const pdf = new window.jsPDF()
            pdf.addImage(png, 'PNG', 5, 5, 200, !inShortVersion ? 160 : 240)
            pdf.save(fileName)

            printAreaElement.style.width = oldWidth
            printAreaElement.style.margin = '0'
        })
    }

    /**
     * Renders the current component.
     *
     * @returns JSX representing the visuals of the current component.
     */
    render() {
        const {classes, formData, resultData} = this.props
        const {takingSnapShot} = this.state
        
        const brandLogo = formData.brandLogo
        const cardLogo = `${window.env.ASSETS_URL}/images/cards/${resultData.cardLogo}.svg`
        let paymentMethod = resultData.paymentMethod
        const isPmc =  (size(paymentMethod) === 1 && head(paymentMethod) === PAGO_MIS_CUENTAS)

        return (
            <MainPaper
                after={
                    !takingSnapShot &&
                    GenerateButtons(classes, formData, this.printVoucher, this.downloadVoucher, isPmc)
                }
            >
                <OfflineFeedbackSheet cardLogo={cardLogo}
                                      brandLogo={brandLogo}
                                      paymentMeanName={resultData.paymentMeanName}
                                      expirationDate={resultData.expirationDate}
                                      amount={resultData.amount}
                                      secondExpirationDate={resultData.secondExpirationDate}
                                      surcharge={resultData.surcharge}
                                      operationNumber={resultData.operationNumber}
                                      barcode={resultData.barCode}
                                      title={formData.title}
                                      isPmc={isPmc}/>
            </MainPaper>
        )
    }


}

function GenerateButtons(classes, formData, printVoucher, downloadVoucher, isPmc) {
  if (isPmc)
    return (
      <PmcVoucherButtons
        classes={classes}
        formData={formData}
      />
    )
  else
    return (
      <OfflineVoucherButtons
        classes={classes}
        printVoucher={printVoucher}
        downloadVoucher={downloadVoucher}
        formData={formData}
      />
    )
}

OfflineFeedbackSheet.propTypes = {
    classes: PropTypes.object
}

const mapStateToProps = state => ({
    formData: state.forms.formData,
    resultData: state.forms.resultData
})

const DataBound = connect(mapStateToProps)(OfflineFeedback)

export default ToplessMain(DataBound)
